import { render, staticRenderFns } from "./nostartPromot.vue?vue&type=template&id=7ba8ad00&scoped=true&"
import script from "./nostartPromot.vue?vue&type=script&lang=js&"
export * from "./nostartPromot.vue?vue&type=script&lang=js&"
import style0 from "./nostartPromot.vue?vue&type=style&index=0&id=7ba8ad00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8ad00",
  null
  
)

export default component.exports